import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ChevronRight, Flame } from "lucide-react";
import { API } from "@/lib/auth";
import { Skel } from "@/components/market/Shared";
import { MarketSheet } from "@/components/predict/MarketSheet";
import { OddsPair } from "@/components/predict/SportsBoard";

export const HotGames = () => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    const get = () => axios.get(`${API}/predict/sports`).then((r) => setD(r.data)).catch(() => setD((x) => x || { games: [] }));
    get(); const iv = setInterval(get, 45000);
    return () => clearInterval(iv);
  }, []);
  const games = (d?.games || []).filter((g) => g.markets.some((m) => m.kind === "Winner" && m.mid != null)).slice(0, 6);
  if (d && !games.length) return null;
  return (
    <section className="space-y-3" data-testid="hot-games">
      <div className="flex items-center justify-between">
        <h2 className="font-head font-extrabold uppercase text-2xl flex items-center gap-2"><Flame className="w-5 h-5 text-[var(--gold)]" />Games coming up</h2>
        <Link to="/sports" className="text-xs font-bold text-[var(--cyan)] flex items-center" data-testid="hot-games-all">All sports<ChevronRight className="w-4 h-4" /></Link>
      </div>
      {!d ? <Skel h="h-40" /> : <div className="flex lg:grid lg:grid-cols-3 gap-3 overflow-x-auto no-scrollbar snap-x -mx-4 px-4 lg:mx-0 lg:px-0">
        {games.map((g) => {
          const w = g.markets.find((m) => m.kind === "Winner" && m.mid != null);
          return (
            <div key={g.key} className="glass p-4 space-y-3 shrink-0 w-[82%] sm:w-[48%] lg:w-auto snap-start min-w-0" data-testid={`hot-game-${g.key}`}>
              <div className="flex justify-between text-[10px] font-bold uppercase tracking-wider text-slate-500"><span>{g.league_name}</span>
                {g.live ? <span className="flex items-center gap-1.5 text-rose-400"><span className="live-dot" />Live</span> : <span className="font-num">{new Date(g.start).toLocaleString([], { weekday: "short", hour: "numeric", minute: "2-digit" })}</span>}</div>
              <div className="font-head font-bold text-lg leading-tight truncate">{g.title}</div>
              <OddsPair m={w} onOpen={setOpen} />
            </div>);
        })}
      </div>}
      <MarketSheet slug={open} onClose={() => setOpen(null)} />
    </section>
  );
};
